<template>
  <div>
    <v-icon color="teal" @click="download">cloud_download</v-icon>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data: () => ({ }),
  methods: {
    download() {
      this.params.clicked(this.params.data);
    },
  },
});
</script>
